
export const advanceSearchEschema = [

{
    id:1,
    name:'Name',
    type:'text',
    labelTitle:'Nombre'
},
{
    id:2,
    name:'DateFrom',
    type:'date',
    labelTitle:'Fecha Desde'
},
{
    id:3,
    name:'DateTo',
    type:'date',
    labelTitle:'Fecha Hasta'
},

{
    id:5,
    name:'FormationPlaceId',
    type:'select',
    select:'true',
    labelTitle:'Lugar de formación'
},
]